/*** IMPORTS FROM imports-loader ***/
var define = false;

export var canUseWeakMap = typeof WeakMap === 'function' && !(typeof navigator === 'object' &&
    navigator.product === 'ReactNative');
export var canUseWeakSet = typeof WeakSet === 'function';
export var canUseSymbol = typeof Symbol === 'function' &&
    typeof Symbol.for === 'function';
//# sourceMappingURL=canUse.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@apollo/client/utilities/common/canUse.js
// module id = 740
// module chunks = 0